module.exports = "<ngx-loading-bar color=\"#008851\"></ngx-loading-bar>\r\n<router-outlet></router-outlet>\r\n"